module.exports = __webpack_public_path__ + "5863f90d123fe626afa1d1a4b4453261.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/planet-asteroid-s.png
// module id = 2521
// module chunks = 0